// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const cleaningProcedureId = (z.number());
export const cleaningProcedure = z.object({
    id: cleaningProcedureId,
    name: z.string(),
    code: z.string(),
    description: z.string().nullable(),
    version: z.string(),
    previous_version_id: cleaningProcedureId.nullable(),
    is_active: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const cleaningProcedureInitializer = z.object({
    id: cleaningProcedureId.optional(),
    name: z.string(),
    code: z.string(),
    description: z.string().optional().nullable(),
    version: z.string().optional(),
    previous_version_id: cleaningProcedureId.optional().nullable(),
    is_active: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const cleaningProcedureMutator = z.object({
    id: cleaningProcedureId.optional(),
    name: z.string().optional(),
    code: z.string().optional(),
    description: z.string().optional().nullable(),
    version: z.string().optional(),
    previous_version_id: cleaningProcedureId.optional().nullable(),
    is_active: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=CleaningProcedure.js.map